/**
 * App language constant.
 */
export const LANGUAGE_TYPE = {
    VI: 'vi',
    ZH: 'zh',
    EN: 'en',
};
